import { DisplayPick } from 'services/picking';
import { WithSearchProps } from 'ui/components/Page/WithSearchResults';
import { SearchableState } from 'services/search';
import { Item } from 'services/items';
import { Tag } from 'services/tags';
import { ReportPreset } from 'services/reports';
import { User } from 'services/user';
import { User as UserV2 } from 'services/userV2';
import { Location } from 'services/locations';
import { Customer } from 'services/customers';
import { OrderPriority } from 'services/settings/orderPriorities';
import { Pagination } from 'services/search';
import { Dates } from 'helpers';
import { PickingBulkActionKey } from './hooks/usePickingBulkActions';

export enum PickingPageAction {
  CUSTOM_FIELDS,
  CHANGE_DATE,
  VOID,
  UNASSIGN,
  GROUP,
  PRINT_TICKETS,
}

export interface PickingPageCmp
  extends React.FunctionComponent<PickingPageContainerProps> {
  route: string;
}

export interface PickingPageContainerProps
  extends WithSearchProps<DisplayPick> {}

export interface PickingDataProps {
  searchResult: SearchableState<DisplayPick>;
  activePickId: number | null;
  reportPresets: ReportPreset[];
  activeUser: User | null;
  flags: Record<string, boolean>;
  users: User[] | UserV2[];
  locations: Location[];
  customers: Customer[];
  orderPriorities: OrderPriority[];
  activeDate: Dates;
  searchItem: Item | null;
  searchTags: Tag[];
}

export interface PickingUiStateProps {
  isVoiding: boolean;
  isGrouping: boolean;
  isLoadingSearchResult: boolean;
  activeDate: Dates;
}

export interface PickingLookupsProps {}

export interface PickingSelectionProps {
  selectedItems: number[];
  setSelectedItems: React.Dispatch<React.SetStateAction<number[]>>;
}

export interface PickingHandlersProps {
  fetchSearchResult: (params?: any) => Promise<void>;
  handlePickClicked: (pickId: number) => void;
  handleDetailsCardClosed: () => void;
  handlePaginationChange: (newPagination: Pagination) => void;
  handlePageAction: (action: PickingPageAction, data?: Dates | any) => void;
  onPrintPickTicketsClicked: () => Promise<void>;
  executePickingBulkAction: (actionKey: PickingBulkActionKey) => Promise<void>;
}

export interface PickingPageViewProps {
  data: PickingDataProps;
  uiState: PickingUiStateProps;
  lookups: PickingLookupsProps;
  selection: PickingSelectionProps;
  handlers: PickingHandlersProps;
}

export interface PickingPageProps extends WithSearchProps<DisplayPick> {}

export interface PriorityLevelType {
  id: number;
  value: string;
}
